import React from "react";
import { IconButton, Tooltip } from "@mui/material";
import { GridCellParams } from "@mui/x-data-grid";

interface ActionItem {
  icon: React.ReactNode;
  tooltip: string;
  onClick: (params: GridCellParams) => void;
  disabled?: boolean;
}

interface ActionMenuProps {
  params: GridCellParams;
  actions: ActionItem[];
}

const ActionMenu: React.FC<ActionMenuProps> = ({ params, actions }) => {
  const visibleActions = actions.filter(action => !action.disabled);

  return (
    <div style={{ display: "flex", gap: "8px" }}>
      {visibleActions.map((action, index) => (
        <Tooltip key={index} title={action.tooltip} arrow>
          <IconButton onClick={() => action.onClick(params)}>
            {action.icon}
          </IconButton>
        </Tooltip>
      ))}
    </div>
  );
};

export default ActionMenu;
